import styled from "styled-components";

export const ActionsSheetComponent = styled.div`
    
`
